import { BaseChartAPIProps, CreateChartOptions } from '~/types/create.types';
import { SeriesType } from '~/types/series.types';
import { TimeSeriesItem, TsDataPoint } from '~/types/timeseries.types';
import { RangeHorizon } from '~/ui/components/resample-selector/ResampleSelector.types';
import { createCanvasContext } from '~/utils/createCanvasContext';
import { getDomainFromHorizon } from '~/utils/time-series';

import { chartStore } from './chart-store/chartStore';
import { reDraw } from './recalculate/recalculate';
import { setup } from './setup/setup';

interface ChartAPIProps {
  canvasElement: HTMLCanvasElement;
  options: CreateChartOptions;
}
interface PaintProps {
  data: TsDataPoint[];
  timeseries: TimeSeriesItem[];
  horizon: RangeHorizon;
}

export interface ChartAPIReturn {
  paint: (props: PaintProps) => void;
  destroy: () => void;
  changeRangeHorizon: (range: RangeHorizon) => void;
  changeSeriesType: (seriesType: SeriesType) => void;
}

export const chartAPI = ({
  canvasElement,
  options,
}: ChartAPIProps): null | ChartAPIReturn => {
  const context = createCanvasContext(canvasElement, options);
  if (!context) {
    return null;
  }

  const chartSetup = setup(canvasElement, options, context);
  chartSetup.setListeners(true);

  return {
    paint: function ({ horizon, data, timeseries }) {
      chartSetup.initialiseData(horizon, data, timeseries);
    },
    destroy: function () {
      chartSetup.setListeners(false);
    },
    changeRangeHorizon: function (horizon: RangeHorizon) {
      const base = chartStore.getState().base as BaseChartAPIProps;
      const domain = getDomainFromHorizon(base.data, horizon, base.lastDataIdx);
      const newBase = chartStore.getState().updateDomain(domain);
      reDraw(newBase);
    },
    changeSeriesType: function (seriesType: SeriesType) {
      const newBase = chartStore.getState().updateSeriesType(seriesType);
      reDraw(newBase);
    },
  };
};
